
import StatusMoreDetailsLink from 'Components/Atoms/A_VViewer/StatusMoreDetailsLink';
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

function ModalActivityLevel({ open, handleClose, volcanoLevels }) {

  return (
      <Dialog maxWidth={"lg"} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle id="activity-levels">
        Estados de alerta volcánica
        <StatusMoreDetailsLink />
        <IconButton aria-label="close" onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8, top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

        <DialogContent>
          <div className="table-content">

            <div className="head-table" about="header">
              <div className="state-activity">
                <p>Estado de alerta</p>
              </div>
              <div className="description">
                <p>Descripción técnica</p>
              </div>
            </div>

            <div className="content-table" about="content">
               {
                  volcanoLevels?.map( (level, index) => (
                     <div
                        key={ level.index_number }
                        id={ index % 2 > 0 ? "BG-g" : "BG-w" } 
                        className="item-content"
                     >
                        <div className="state-activity-content">
                           <div className="state-activity-columns">
                              <div className="color-content">
                                 <img alt="state" src={ level.icon }></img>
                                 <p className="title">{ level.title }</p>
                              </div>
                              <div className="text-content">
                                 <p>{ level.short_description }</p>
                              </div>
                           </div>
                        </div>
                        <div className="description-content">
                           <p>{ level.description }</p>
                        </div>
                     </div>
                  ))
               }
            </div>
          </div>
        </DialogContent>
      </Dialog>
  );
}

export default ModalActivityLevel;
